export default "__VITE_ASSET__BqjNZkEw__"